/**
 *
 * WorkCloud
 *
 */

import React from "react"
import ReactWordcloud from "react-wordcloud"
import { loadTexts, sanitize } from "../../utils/i18n"
import "./index.less"

const options = {
  colors: ["#0385FF", "#51a9fd", "#71b8fc"],
  enableTooltip: true,
  deterministic: false,
  fontFamily: "Segoe UI",
  fontSizes: [18, 35],
  fontStyle: "normal",
  fontWeight: "600",
  padding: 5,
  rotations: 1,
  rotationAngles: [0, 0],
  scale: "log",
  spiral: "rectangular",
  transitionDuration: 1000,
  enableOptimizations: true,
}

function WordCloud({ words }) {
  const intlEmptyWordCloud = loadTexts("reports_qualitative_questions_view")
    .emptyWordCloud
  if (words.length === 0) {
    return (
      <div className="wordCloud-Component-empty">
        <p>{sanitize(intlEmptyWordCloud)}</p>
      </div>
    )
  }
  return <ReactWordcloud options={options} words={words} />
}

WordCloud.propTypes = {}

export default React.memo(WordCloud)
